export class Spectrum {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this._resize();
    window.addEventListener('resize', () => this._resize());
  }

  _resize() {
    const rect = this.canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio;
    this.canvas.width = rect.width * dpr;
    this.canvas.height = rect.height * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.width = rect.width;
    this.height = rect.height;
  }

  draw(fftData) {
    const ctx = this.ctx;
    const w = this.width;
    const h = this.height;

    ctx.clearRect(0, 0, w + 1, h + 1);

    if (!fftData || fftData.length === 0) return;

    // Use lower half of FFT data (more useful frequency range)
    const len = Math.floor(fftData.length * 0.6);
    const barWidth = w / len;

    for (let i = 0; i < len; i++) {
      // FFT data is in dB, normalize to 0-1
      const db = fftData[i];
      const norm = Math.max(0, (db + 100) / 100);
      const barHeight = norm * h * 0.9;

      const x = i * barWidth;
      const y = h - barHeight;

      // Gradient from cyan (low) to magenta (high)
      const t = i / len;
      const r = Math.round(t * 255);
      const g = Math.round((1 - t) * 255);
      const b = Math.round(200 + t * 55);

      // Main bar
      ctx.fillStyle = `rgba(${r}, ${g}, ${b}, 0.7)`;
      ctx.fillRect(x, y, barWidth - 1, barHeight);

      // Glow on top
      const gradient = ctx.createLinearGradient(x, y, x, y + Math.min(barHeight, 20));
      gradient.addColorStop(0, `rgba(${r}, ${g}, ${b}, 0.8)`);
      gradient.addColorStop(1, 'transparent');
      ctx.fillStyle = gradient;
      ctx.fillRect(x, y, barWidth - 1, Math.min(barHeight, 20));

      // Reflection
      ctx.fillStyle = `rgba(${r}, ${g}, ${b}, 0.1)`;
      ctx.fillRect(x, h, barWidth - 1, -barHeight * 0.15);
    }
  }
}
